import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Page } from "@/components/SiteLayout";

export default function RecoverAccess() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/access/resend", { email });
      setMsg(r.data.message);
    } catch (err) {
      setMsg(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Page>
      <form onSubmit={submit} className="mx-auto max-w-md px-5 py-12" data-testid="recover-form">
        <h1 className="text-3xl text-stone-900">Recuperar acesso</h1>
        <p className="mt-3 text-stone-600">Informe o e-mail usado na compra. Se houver um pagamento confirmado, enviaremos um novo link individual (o anterior deixa de funcionar).</p>
        <input required type="email" className="field mt-6" placeholder="seu@email.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="recover-email-input" />
        <button className="btn-primary mt-4 w-full" disabled={busy} data-testid="recover-submit-button">{busy ? "Enviando…" : "Enviar novo link"}</button>
        {msg && <p className="mt-5 rounded-xl bg-[#f5efe6] p-4 text-sm text-stone-700" data-testid="recover-message">{msg}</p>}
      </form>
    </Page>
  );
}
